import { render, staticRenderFns } from "./DashboardGantt.vue?vue&type=template&id=4975bd6e&scoped=true&"
import script from "./DashboardGantt.vue?vue&type=script&lang=js&"
export * from "./DashboardGantt.vue?vue&type=script&lang=js&"
import style0 from "./DashboardGantt.vue?vue&type=style&index=0&id=4975bd6e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4975bd6e",
  null
  
)

export default component.exports